import { render, staticRenderFns } from "./NoticeRecord.vue?vue&type=template&id=4a3bcf4c&scoped=true"
import script from "./NoticeRecord.vue?vue&type=script&lang=js"
export * from "./NoticeRecord.vue?vue&type=script&lang=js"
import style0 from "./NoticeRecord.vue?vue&type=style&index=0&id=4a3bcf4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3bcf4c",
  null
  
)

export default component.exports